module.exports = __webpack_public_path__ + "img/1485381572.9d69c857.jpg";